import { Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class ErrorService {
  constructor() {}

  getErrorMessage(err: HttpErrorResponse): string {
    let defaultErrorCode = errorCodes.find(
      (errorCodeObj) => errorCodeObj.code == "default"
    );
    let errorMessage = defaultErrorCode.msg;
    if (
      err &&
      err.error &&
      !err.error.Error &&
      (err.status === 401 || err.status === 403)
    ) {
      let unauthorizedErrorCode = errorCodes.find(
        (errorCodeObj) => errorCodeObj.code == "unauthorized"
      );
      errorMessage = unauthorizedErrorCode.msg;
    } else if (err && err.error && err.error.Error) {
      if (err.error.Error.errorCode || err.error.Error.message) {
        let errorCode = errorCodes.find(
          (errorCodeObj) =>
            !!errorCodeObj.code &&
            !!err.error.Error.errorCode &&
            errorCodeObj.code.toLowerCase() ==
              err.error.Error.errorCode.toLowerCase()
        );
        if (errorCode) {
          errorMessage = errorCode.msg;
        } else if (err.error.Error.message) {
          errorMessage = err.error.Error.message;
        }
      }
    }
    return errorMessage;
  }

  getClientMessage(error: Error): string {
    if (!navigator.onLine) {
      return "No Internet Connection";
    }
    return error.message ? error.message : error.toString();
  }

  getClientStack(error: Error): string {
    return error.stack;
  }

  getServerMessage(error: HttpErrorResponse): string {
    return this.getErrorMessage(error);
  }

  getServerStack(error: HttpErrorResponse): string {
    return error.message;
  }
}

export const errorCodes = [
  {
    code: "app.invalidateCredential",
    msg: "Your login id or password is incorrect, please try again.",
  },
  {
    code: "app.invalidEmail",
    msg: "Sorry, we're unable to find a user for that email address. Please enter the email address you used to register for UnityC.",
  },
  {
    code: "app.accountLockedOut",
    msg: "Your credentials are locked. Please contact the Unity support team at unity.support@dyedurham.com or toll free at 1.866.367.7648.",
  },
  {
    code: "app.alreadyExistsUserId",
    msg: "This email already exists. If you have an account, please login or register with a different email.",
  },
  {
    code: "app.cirf.cannot.update.cancelled.cirf",
    msg: "Request for Information has been withdrawn. Please contact the law firm if you have concerns.",
  },
  {
    code: "app.unity.connect.cannot.create.message",
    msg: "Unable to send message at this time.  Try again later.",
  },
  {
    code: "system.errors",
    msg: "There seems to be a problem with your request. Please contact the Unity support team at unity.support@dyedurham.com or toll-free at 1.866.367.7648.",
  },
  {
    code: "system.error",
    msg: "There seems to be a problem with your request. Please contact the Unity support team at unity.support@dyedurham.com or toll-free at 1.866.367.7648.",
  },
  { code: "unauthorized", msg: "UnityC timed out. Please log in again." },
  {
    code: "invalid.provider.token",
    msg: "Please contact your lawyer as a payment provider is not currently setup",
  },
  {
    code: "default",
    msg: "There seems to be a problem with your request. Please contact the Unity support team at unity.support@dyedurham.com or toll-free at 1.866.367.7648.",
  },
];
